const APP_ICON = '/logo512.png';
const APP_NAME = 'Dewatanet HRIS';

export const isNotificationSupported = () => {
  try {
    return typeof window !== 'undefined' && typeof Notification !== 'undefined';
  } catch {
    return false;
  }
};

export const getNotificationPermission = () => {
  if (!isNotificationSupported()) return 'unsupported';
  return Notification.permission;
};

export const requestNotificationPermission = async () => {
  if (!isNotificationSupported()) return 'unsupported';
  if (Notification.permission === 'granted') return 'granted';
  if (Notification.permission === 'denied') return 'denied';

  try {
    return await Notification.requestPermission();
  } catch (error) {
    console.error('[deviceNotifications] requestPermission failed:', error);
    return 'denied';
  }
};

export const registerServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' });
    await navigator.serviceWorker.ready;
    // Paksa update SW agar push handler terbaru aktif
    reg.update().catch(() => {});
    return reg;
  } catch (error) {
    console.warn('[deviceNotifications] service worker register failed:', error);
    return null;
  }
};

/**
 * Tampilkan notifikasi lewat Service Worker (lebih andal di HP / PWA).
 * Fallback ke Notification API jika SW belum siap.
 */
export const showDeviceNotification = async ({
  title = APP_NAME,
  body = '',
  tag,
  url = '/',
  onClick,
}) => {
  if (!isNotificationSupported() || Notification.permission !== 'granted') return null;
  if (!body) return null;

  const options = {
    body,
    icon: APP_ICON,
    badge: APP_ICON,
    tag: tag || `hris-${Date.now()}`,
    renotify: true,
    silent: false,
    data: { url },
  };

  try {
    if ('serviceWorker' in navigator) {
      const reg = await navigator.serviceWorker.ready;
      if (reg?.showNotification) {
        await reg.showNotification(title, options);
        return true;
      }
    }

    const notification = new Notification(title, options);
    notification.onclick = (event) => {
      event.preventDefault();
      window.focus();
      if (url && url !== '/') {
        window.location.href = url;
      }
      notification.close();
      onClick?.();
    };
    setTimeout(() => notification.close(), 12000);
    return notification;
  } catch (error) {
    console.error('[deviceNotifications] show failed:', error);
    return null;
  }
};
